import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Zap, MessageSquareText, CalendarCheck, ArrowRight } from 'lucide-react';
interface AISolutionSlideProps {
  content: {
    headline: string;
    steps: Array<{
      title: string;
      description: string;
    }>;
    source: string;
  };
}
export function AISolutionSlide({
  content
}: AISolutionSlideProps) {
  const icons = [Zap, MessageSquareText, CalendarCheck];
  return <div className="bg-[#F5F5F5] rounded-2xl p-16 min-h-[600px] flex flex-col relative" data-id="element-53">
      <motion.h2 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl md:text-5xl font-bold text-[#1C1C1C] mb-20 text-center" data-id="element-54">
        {content.headline}
      </motion.h2>

      <div className="flex-1 flex items-center justify-center gap-4 md:gap-8 relative" data-id="element-55">
        {content.steps.map((step, index) => {
        const Icon = icons[index];
        return <Fragment key={index} data-id="element-56">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + index * 0.3
          }} className="flex-1 bg-white rounded-2xl p-8 shadow-lg border border-[#0FB07D]/20 relative z-10 flex flex-col items-center text-center" data-id="element-57">
                <div className="w-20 h-20 bg-[#017C6D]/10 rounded-full flex items-center justify-center mb-6" data-id="element-58">
                  <Icon className="w-10 h-10 text-[#017C6D]" data-id="element-59" />
                </div>
                <div className="text-sm font-bold text-[#0FB07D] tracking-wider mb-2 uppercase" data-id="element-60">
                  Step {index + 1}
                </div>
                <h3 className="text-2xl font-bold text-[#1C1C1C] mb-4" data-id="element-61">
                  {step.title}
                </h3>
                <p className="text-[#4D4D4D] text-lg leading-relaxed" data-id="element-62">
                  {step.description}
                </p>
              </motion.div>

              {/* Arrow between steps */}
              {index < content.steps.length - 1 && <motion.div initial={{
            opacity: 0,
            scale: 0
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.4 + index * 0.3
          }} className="hidden md:flex text-[#0FB07D] z-0" data-id="element-63">
                  <ArrowRight size={48} strokeWidth={1.5} data-id="element-64" />
                </motion.div>}
            </Fragment>;
      })}
      </div>

      <div className="absolute bottom-6 right-8 text-sm text-[#4D4D4D]/60 font-medium" data-id="element-65">
        {content.source}
      </div>
    </div>;
}
export default AISolutionSlide;